import { useEffect, useState } from "react";
import CancelTransactionModal from "../../../components/Modals/CancelTransactionModal";
import { PrimaryButton, SmallButton } from "../../../components/Buttons";
import { Dropdown, FormInputField, Label } from "../../../components";
import SelectAccountDropdown from "../../../components/Common/SelectAccountDropdown";
import {
  FormatBalance,
  FormatTRDate,
  GetCurrenySymbol,
  GetValidationErrors,
} from "../../../helper";
import FormTextAreaField from "../../../components/FormTextAreaField";
import { useDispatch, useSelector } from "react-redux";
import { useDeleteDocument, useForm, useModules } from "../../../hooks";
import {
  CryptoBitpaceWithdraw,
  CryptoWithdraw,
  UpdateCryptoWithdraw,
} from "../../../redux/actions/CryptoTransaction/Withdraw";
import TransactionOTPModal from "../../../components/Modals/TransactionsOTPModal";
import { verifyTROTP } from "../../../redux/actions/TRrequest/OTPVerification";
import ErrorMessage from "../../../components/Common/ErrorMessage";
import ConfirmWithdrawCrypto from "../../../components/Modals/ConfirmWithdrawCrypto";
import { getTransactionDetails } from "../../../redux/actions/Transaction/TransactionHistory";
import { useLocation } from "react-router-dom";
import OrderComplete from "../../../components/Crypto/OrderComplete";
import { TransactionDetail } from "../../../components/Transactions";
import { setActiveAccount } from "../../../redux/actions/home/ActiveAccountAction";
import PreviousDocs from "../../../components/Common/PreviousDocs";
import { setPageTitle } from "../../../helper/metaDataHelper";
import ViewSupportingDocument from "../../../components/Common/ViewSupportingDocument";
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import { GetCurrencyNetwork } from "../../../redux/actions/CryptoTransaction/GetCurrencyNetwork";
import CryptoNetworksDropdown from "../../../components/Crypto/CryptoNetworksDropdown";
import { EmptyCurrencyListIcons, QRCodeIcon } from "../../../components/Icons";
import CommonButton from "../../../components/Buttons/CommonButton";
import AddAccountModal from "../../../components/Modals/AddAccount/AddAccountModal";
import { ValidateFileSize } from "../../../utils/ValidateFileSize";
import JsQRScanner from "../../../components/ORScanner";
import useVASPList from "../../../hooks/useVASPList";
import CommonDropdown from "../../../components/Common/CommonDropdown";
import CheckBox from "../../../components/Common/CheckBox";

// handle the error messages and add an api to get the max and min count for currencies from bitpace.
const Withdraw = () => {
  const dispatch = useDispatch();
  const amount = useForm("", "crypto_amount");
  const remarksInput = useForm("");
  const walletAddress = useForm("");
  const cryptoNetwork = useForm("");
  const [cryptoCurrencyNetworks, setCryptoCurrencyNetworks] = useState([]);
  const [loadingNetworks, setLoadingNetworks] = useState(false);
  const transactionDate = FormatTRDate(new Date(), "DDMMYYYY");
  const [supportingDocument, setSupportingDocument] = useState([]);
  const [files, setFiles] = useState([]);
  const { documents, setDocuments, handleDeleteDocument } = useDeleteDocument(
    [],
  );
  const [confirmModal, setConfirmModal] = useState(false);

  const { activeAccount } = useSelector((state) => state.activeAccount);
  const isModuleEnabled = useModules("Bitpace");
  const [isLoading, setIsLoading] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [trn_id, setTrnId] = useState("");
  const [isError, setIsError] = useState(false);
  const [isFileValidation, setIsFileValidation] = useState(false);
  const vaspOptions = useVASPList();
  const declareWallet = useForm(false);

  const selectedVASP = useForm("");
  const beneficiaryType = useForm("");
  const beneficiaryFirstName = useForm("");
  const beneficiaryLastName = useForm("");
  const bussinessLegalName = useForm("");
  const beneficiaryVASPName = useForm("");
  const walletType = useForm("");
  const sandToMyself = useForm(false);
  const VASPNotInList = useForm(false);

  const [order, setOrder] = useState({
    status: "",
    account: "",
    amount: "",
    transactionDate: "",
    remarks: "",
    supportingDocument: "",
    walletAddress: "",
  });

  const cryptoAccount = useSelector(
    (state) => state.client.clientInfo.crypto_accounts,
  );

  const [allowedAccounts, setAllowedAccounts] = useState([]);

  const { state } = useLocation();

  useEffect(() => {
    setPageTitle("Crypto Withdraw");
    const filteredAccounts = isModuleEnabled
      ? cryptoAccount.filter((acc) => acc.bitpace_withdraw_allowed === true)
      : cryptoAccount;
    setAllowedAccounts(filteredAccounts);
    if (filteredAccounts.length > 0) {
      dispatch(setActiveAccount(filteredAccounts[0]));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const networks = async () => {
      const data = {
        currency_code: activeAccount.currency_code,
        account_id: activeAccount.id,
      };
      setCryptoCurrencyNetworks([]);
      cryptoNetwork.setError("");
      cryptoNetwork.setValue("");
      setLoadingNetworks(true);

      const networks = await dispatch(GetCurrencyNetwork(data));

      if (networks.status === "DECLINED") {
        setIsError(networks.message);
        cryptoNetwork.setError("Something went wrong");
      } else if (networks.data && networks.data.length === 0) {
        setIsError(
          `No network available for the ${activeAccount.currency_code} currency.`,
        );
        cryptoNetwork.setError("No network available for the currency");
        setCryptoCurrencyNetworks([]);
      } else {
        setCryptoCurrencyNetworks(networks.data);
        // cryptoNetwork.setValue(networks.data[0]);
      }

      setLoadingNetworks(false);
    };

    if (activeAccount && isModuleEnabled) {
      networks();
    }
    // eslint-disable-next-line
  }, [activeAccount, isModuleEnabled]);

  useEffect(() => {
    if (state) {
      // get transaction details
      const fetchTransactionDetails = async () => {
        const data = {
          trn_id: state.transaction.id,
          transaction_nature: "Withdraw",
        };
        setIsLoading(true);
        const res = await dispatch(getTransactionDetails(data));
        if (res.success) {
          amount.setValue(res.data.crypto_amount);
          remarksInput.setValue(res.data.remarks);
          walletAddress.setValue(res.data.to_wallet_address);

          const crypto = allowedAccounts.find(
            (account) => account.id === parseInt(res.data.account_id),
          );

          dispatch(setActiveAccount(crypto));

          if (res.data.docs && res.data.docs.length > 0) {
            setDocuments(res.data.docs);
          }
        }
        setIsLoading(false);
      };
      fetchTransactionDetails();
    }
  }, [state, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleWithdraw = async () => {
    try {
      setConfirmModal(false);
      setIsOTPModalOpen(true);
      setIsLoading(true);

      const data = new FormData();
      data.append("account_id", activeAccount.id);
      data.append("amount", amount.value);
      data.append("remarks", remarksInput.value);
      data.append("to_wallet_address", walletAddress.value);
      data.append("transaction_date", transactionDate);

      if (isModuleEnabled) {
        // new bitpace fields
        data.append("beneficiary_type", beneficiaryType.value);
        data.append("beneficiary_first_name", beneficiaryFirstName.value);
        data.append("beneficiary_last_name", beneficiaryLastName.value);
        data.append("beneficiary_legal_name", bussinessLegalName.value);
        data.append("wallet_type", walletType.value);
        data.append("is_sending_to_myself", sandToMyself.value);
        data.append("is_not_on_vasp_list", VASPNotInList.value);
        data.append("is_ownership_declaration", declareWallet.value);

        if (!VASPNotInList.value) {
          data.append("beneficiary_vasp_did", selectedVASP.value.value);
          data.append("beneficiary_vasp_name", selectedVASP.value.label);
        } else {
          data.append("beneficiary_vasp_name", beneficiaryVASPName.value);
        }

        data.append("crypto_network", cryptoNetwork.value);
      }

      if (supportingDocument) {
        Object.keys(supportingDocument).forEach((key) => {
          supportingDocument[key].forEach((file) => {
            data.append("supporting_documents[]", file);
          });
        });
      }

      let res;
      if (state) {
        data.append("trn_id", state.transaction.id);
        res = await dispatch(UpdateCryptoWithdraw(data));
      } else {
        if (isModuleEnabled) {
          res = await dispatch(CryptoBitpaceWithdraw(data));
        } else {
          res = await dispatch(CryptoWithdraw(data));
        }
      }
      setIsLoading(false);

      if (res.success) {
        setIsOTPModalOpen(true);
        setTrnId(res.data.trn_id);
      } else if (!res.success) {
        setIsOTPModalOpen(false);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);

        if (res.errors) {
          setIsError(GetValidationErrors(res.errors));
        } else {
          setIsError(res.message === "Exception" ? res.error : res.message);
        }
      }
    } catch (error) {
      setIsError(error.message);
      console.error("error", error);
      setIsLoading(false);
    }
  };

  const validateWithdraw = () => {
    let hasError = false;

    const setErrorFlag = (setter, message = true) => {
      hasError = true;
      setter(message);
    };

    const amountValue = Number(amount.value);
    const balance = Number(activeAccount.balance);

    // Amount validation
    if (amount.validate()) {
      setErrorFlag(amount.setError, "Please enter a valid amount");
    }

    // Balance validation
    if (balance < 0 || amountValue > balance) {
      setErrorFlag(
        setIsError,
        `Insufficient balance in your ${activeAccount.title} account`,
      );
      setErrorFlag(amount.setError);
    }

    // Min / Max validation
    if (
      amountValue < activeAccount.min_amount ||
      amountValue > activeAccount.max_amount
    ) {
      setErrorFlag(
        setIsError,
        `Amount should be between ${activeAccount.min_amount} and ${activeAccount.max_amount}`,
      );
      setErrorFlag(amount.setError);
    }

    // Crypto network validation
    if (isModuleEnabled && !cryptoNetwork.value) {
      setErrorFlag(cryptoNetwork.setError, "Please select a crypto network");
    }

    // Wallet address validation
    if (!walletAddress.value) {
      setErrorFlag(walletAddress.setError, "Please enter a wallet address");
    }

    // Remarks validation
    if (!remarksInput.value) {
      setErrorFlag(remarksInput.setError, "Please enter remarks");
    }

    // -------------------------------
    // Bitpace new fields validation
    // -------------------------------
    if (isModuleEnabled) {
      if (!beneficiaryType.value) {
        setErrorFlag(beneficiaryType.setError, "Please select beneficiary type");
      }

      if (beneficiaryType.value === "INDIVIDUAL") {
        if (!beneficiaryFirstName.value) {
          setErrorFlag(
            beneficiaryFirstName.setError,
            "Please enter beneficiary first name",
          );
        }

        if (!beneficiaryLastName.value) {
          setErrorFlag(
            beneficiaryLastName.setError,
            "Please enter beneficiary last name",
          );
        }
      }

      if (
        beneficiaryType.value === "BUSSINESS" &&
        !bussinessLegalName.value &&
        !sandToMyself.value
      ) {
        setErrorFlag(bussinessLegalName.setError, "Please enter business legal name");
      }

      if (!walletType.value) {
        setErrorFlag(walletType.setError, "Please select wallet type");
      }

      if (walletType.value === "SELF_HOSTED" && !declareWallet.value) {
        setErrorFlag(declareWallet.setError, "Please accept that, ownership of this wallet");
      }
      if (walletType.value === "CUSTODIAL") {
        if (!VASPNotInList.value && (!selectedVASP?.value?.value || !selectedVASP.value.label)) {
          setErrorFlag(selectedVASP.setError, "Please select beneficiary VASP");
        }
      }
    }
    return hasError;
  };

  const handleViewTransaction = () => {
    setIsOTPModalOpen(false);
    setOrder({
      status: "COMPLETED",
      account: activeAccount,
      amount: amount.value,
      transactionDate: transactionDate,
      remarks: remarksInput.value,
      walletAddress: walletAddress.value,
    });
  };

  const repeatTransaction = () => {
    setOrder({
      status: "",
    });
    setIsOTPModalOpen(false);
    amount.reset();
    remarksInput.reset();
    walletAddress.reset();
    cryptoNetwork.reset();
    setSupportingDocument("");
    setFiles([]);
  };

  const handleFileChange = (name, selectedFiles) => {
    const sizeErrors = [];

    Array.from(selectedFiles).forEach((file) => {
      const { isValid, error } = ValidateFileSize(file);
      if (!isValid) {
        sizeErrors.push(error);
      }
    });

    if (sizeErrors.length > 0) {
      setIsError(sizeErrors);
      setIsFileValidation(true);
    } else {
      setIsError(false);
      setIsFileValidation(false);
    }

    setSupportingDocument((prevFiles) => {
      const updatedFiles = { ...prevFiles, [name]: selectedFiles };
      if (!selectedFiles.length) {
        delete updatedFiles[name];
        return "";
      }
      return updatedFiles;
    });
  };

  // const canSubmit =
  //   remarksInput.value !== "" &&
  //   amount.value !== "" &&
  //   walletAddress.value !== "";
  const isContinueEnabled = !isFileValidation;

  return (
    <>
      {order.status === "COMPLETED" ? (
        <div className="max-w-[992px] mx-auto">
          <div className="flex flex-col items-center justify-center md:p-6">
            <div className="md:w-[568px] w-full px-2">
              <OrderComplete
                message=" will be transferred to the account details provided below."
                repeatTransaction={repeatTransaction}
                coinAmount={order.amount + " " + order.account.currency_code}
              >
                <TransactionDetail
                  label="Transaction type"
                  value={"Withdraw"}
                />
                <TransactionDetail label="Status" value={"Pending"} />
                <hr className="w-full mt-4 border-divider" />
                <TransactionDetail
                  label="from"
                  value={`${order.account.title}`}
                />
                <TransactionDetail
                  label="To Wallte Address"
                  value={order.walletAddress}
                />

                <hr className="w-full mt-4 border-divider" />
                <TransactionDetail
                  label="Crypto currency amount"
                  value={`${order.amount} ${order.account.currency_code}`}
                />
                <TransactionDetail label="Remarks" value={order.remarks} />
                <hr className="w-full mt-4 border-divider" />
                <TransactionDetail
                  label="Transaction date"
                  value={order.transactionDate}
                />
                {supportingDocument && (
                  <TransactionDetail
                    label="Supporting documents"
                    value={
                      <ViewSupportingDocument
                        supportingDocument={supportingDocument}
                      />
                    }
                  />
                )}
              </OrderComplete>
            </div>
          </div>
        </div>
      ) : (
        <main className="pb-16 min-h-screen">
          <div className="max-w-4xl mx-auto p-6 max-[360px]:p-4 bg-background-surface rounded-3xl shadow-box-shadow">
            <div className="flex justify-between items-center mb-4">
              <h1 className="text-2xl font-bold mb-4 page-title">
                Withdraw Crypto
              </h1>
              <CancelTransactionModal
                contextLabel="Cancel Withdraw"
                navigateTo="/crypto"
              >
                <SmallButton text={"Cancel"} cancel={true} />
              </CancelTransactionModal>
            </div>
            {isError && (
              <ErrorMessage
                message={isError}
                onClose={() => setIsError(false)}
              />
            )}

            {allowedAccounts.length === 0 ? (
              <div className="flex flex-col items-center justify-center space-y-10">
                <EmptyCurrencyListIcons className="w-40 h-40" />
                <h2 className="font-normal text-center text-text-secondary">
                  It looks like you don't have a <b>USDT</b> currency account
                  yet! To make withdrawals, you'll need to add one. Just click
                  the button below to get started!
                </h2>
                <AddAccountModal crypto={true}>
                  <CommonButton>Add Currency Account</CommonButton>
                </AddAccountModal>
              </div>
            ) : (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label
                      className="block text-base font-medium text-text-primary mb-2"
                      htmlFor="cryptoAccount"
                      text="From Crypto Account "
                    />
                    <SelectAccountDropdown
                      title={"Select crypto account"}
                      setAccount={(account) => {
                        dispatch(setActiveAccount(account));
                        amount.reset();
                        setIsError("");
                      }}
                      accounts={allowedAccounts}
                      slectedAccount={activeAccount}
                    />
                    <FormInputField
                      label={`${
                        activeAccount?.currency_code || ""
                      } Amount to Withdraw`}
                      name="amount"
                      id="amount"
                      type="number"
                      placeholder={`Enter amount in ${activeAccount.currency_code}`}
                      required={true}
                      onChange={(e) => {
                        amount.setValue(parseFloat(e.target.value));
                      }}
                      {...amount}
                      currency={GetCurrenySymbol(
                        activeAccount.currency_code,
                        "13",
                        "13",
                      )}
                    />
                    {activeAccount.min_amount && activeAccount.max_amount && (
                      <p className="text-xs text-text-primary mx-2 my-1">
                        {`Limits: (min: ${activeAccount.min_amount} , max: ${activeAccount.max_amount})`}
                      </p>
                    )}
                  </div>
                  <div className="md:mt-8">
                    <FormInputField
                      id="account_balance"
                      label="Account Balance"
                      type="text"
                      value={
                        FormatBalance(activeAccount?.balance, true) || "--"
                      }
                      currency={GetCurrenySymbol(
                        activeAccount.currency_code,
                        "13",
                        "13",
                      )}
                      error={true}
                      readOnly={true}
                    />
                    <div className="my-3">
                      <FormInputField
                        label="Transaction Date"
                        name="transaction_date"
                        id="transaction_date"
                        type="text"
                        value={transactionDate}
                        onChange={() => {}}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                  <div className="col-span-1 md:col-span-1">
                    <FormTextAreaField
                      label="Remarks"
                      name="remarks"
                      id="remarks"
                      rows="5"
                      cols="33"
                      placeholder="Please provide relevant remarks for the transaction."
                      {...remarksInput}
                    />
                  </div>
                  <div className="col-span-1 md:col-span-1 space-y-3">
                    <span className="flex items-center max-lg:space-x-3">
                      <FormInputField
                        label="To Wallet Address"
                        name="to_wallet_address"
                        id="to_wallet_address"
                        type="text"
                        placeholder="Wallet Address for Crypto Deposit."
                        icon={
                          <JsQRScanner onScan={walletAddress.setValue}>
                            <QRCodeIcon className="w-6 h-6 QR-code-icon cursor-pointer" />
                          </JsQRScanner>
                        }
                        {...walletAddress}
                      />
                    </span>
                    {isModuleEnabled && (
                      <div className="">
                        <CryptoNetworksDropdown
                          id="cryptoAccount"
                          networks={cryptoCurrencyNetworks}
                          value={cryptoNetwork.value}
                          onChange={(network) => {
                            cryptoNetwork.setValue(network);
                            cryptoNetwork.setError("");
                          }}
                          label="Select network"
                          placeholder="Select crypto network"
                          error={cryptoNetwork.error}
                          loading={loadingNetworks}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                  <div>
                    <MultipleFileUpload
                      name="supporting_documents"
                      id="supporting_documents"
                      title={"Supporting document"}
                      onChange={handleFileChange}
                      isMultiple={true}
                      maxCount={5}
                      mandatory={true}
                      files={files}
                      setFiles={setFiles}
                    />
                  </div>

                  <PreviousDocs
                    documents={documents}
                    handleDeleteDocument={handleDeleteDocument}
                  />
                </div>

                {isModuleEnabled && (
                  <>
                    <hr className="w-full mt-4 border-divider pt-4" />

                    <div className="pb-2">
                      <Label
                        className="block text-base font-medium text-text-primary"
                        htmlFor="crypto_beneficiary"
                        text="Beneficiary Information"
                      />
                      <label className="text-xs font-normal review-card-detail-lable">
                        Check this box if the destination wallet is owned and
                        controlled by your entity. The system will automatically
                        set the Beneficiary Type to BUSINESS and populate the
                        Beneficiary Legal Name with your registered Merchant
                        Name.
                      </label>

                      <div className="col-span-1 md:col-span-1 space-y-3">
                        <CheckBox
                          id="send_to_myself"
                          checked={sandToMyself.value}
                          onChange={(e) => {
                            sandToMyself.setValue(e.target.checked);
                            if (e.target.checked) {
                              beneficiaryType.setValue("BUSINESS");
                              bussinessLegalName.setValue("");
                            } else {
                              bussinessLegalName.setValue("");
                            }
                          }}
                          label={"Sending to myself"}
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                      {!sandToMyself.value && (
                        <div className="col-span-1 md:col-span-1 space-y-3">
                          <span className="flex items-center max-lg:space-x-3">
                            <Dropdown
                              label="Beneficiary Type"
                              name="beneficiary_type"
                              placeholder="Select beneficiary type"
                              options={[
                                { label: "Individual", value: "INDIVIDUAL" },
                                { label: "Business", value: "BUSINESS" },
                              ]}
                              value={beneficiaryType.value}
                              disabled={sandToMyself.value}
                              onChange={(e) => {
                                beneficiaryType.setValue(e.target.value);
                                beneficiaryFirstName.setValue("");
                                beneficiaryLastName.setValue("");
                                bussinessLegalName.setValue("");
                              }}
                            />
                          </span>
                        </div>
                      )}

                      <div className="col-span-1 md:col-span-1 space-y-3">
                        <span className="flex items-center max-lg:space-x-3">
                          <Dropdown
                            label="Wallet Type"
                            name="wallet_type"
                            placeholder="Select wallet type"
                            options={[
                              {
                                label: "Custodial (Exchange/Third-party)",
                                value: "CUSTODIAL",
                              },
                              {
                                label: "Self-Hosted (Ledger, MetaMask, etc.)",
                                value: "SELF_HOSTED",
                              },
                            ]}
                            value={walletType.value}
                            onChange={(e) => {
                              walletType.setValue(e.target.value);
                              selectedVASP.setValue("");
                            }}
                          />
                        </span>
                        {/* <label className="text-xs font-normal review-card-detail-lable">
                       CUSTODIAL: Wallet managed by third-party (e.g., Binance, Coinbase). SELF-HOSTED: Wallet managed directly by user (e.g., Ledger, MetaMask, Trust Wallet).
                    </label> */}
                      </div>

                      {beneficiaryType.value === "BUSINESS" &&
                        !sandToMyself.value && (
                          <div className="col-span-1 md:col-span-1">
                            <FormInputField
                              id="beneficiary_legal_name"
                              label="Beneficiary Legal Name"
                              type="text"
                              placeholder={"Enter beneficiary legal name"}
                              readOnly={sandToMyself.value}
                              // isDisabled={!sandToMyself.value}
                              {...bussinessLegalName}
                            />
                          </div>
                        )}

                      {beneficiaryType.value === "INDIVIDUAL" && (
                        <>
                          <div className="col-span-1 md:col-span-1">
                            <FormInputField
                              id="first_name"
                              label="First Name"
                              type="text"
                              placeholder={"Enter First Name"}
                              {...beneficiaryFirstName}
                            />
                          </div>

                          <div className="col-span-1 md:col-span-1">
                            <FormInputField
                              id="last_name"
                              label="Last Name"
                              type="text"
                              placeholder={"Enter Last Name"}
                              {...beneficiaryLastName}
                            />
                          </div>
                        </>
                      )}

                      {walletType.value === "CUSTODIAL" && (
                        <div className="col-span-1 md:col-span-1 space-y-3">
                          <CommonDropdown
                            id="beneficiary_vasp"
                            label="Beneficiary VASP (Exchange)"
                            placeholder="Select beneficiary VASP (Exchange)"
                            options={vaspOptions}
                            value={selectedVASP.value}
                            isLoading={!vaspOptions}
                            onChange={(option) => {
                              selectedVASP.setValue(option);
                              selectedVASP.setError("");
                            }}
                            readOnly={VASPNotInList.value}
                            error={selectedVASP.error}
                          />
                        </div>
                      )}

                      {VASPNotInList.value && (
                        <div className="col-span-1 md:col-span-1 space-y-3">
                          <FormInputField
                            id="beneficiary_vasp"
                            label="Beneficiary VASP (Exchange)"
                            placeholder="Enter beneficiary VASP (Exchange)"
                            type="text"
                            {...beneficiaryVASPName}
                          />
                        </div>
                      )}
                    </div>

                    {walletType.value === "SELF_HOSTED" && (
                      <div className="flex flex-col pt-4">
                        <CheckBox
                          id="self_hosted"
                          checked={declareWallet.value}
                          onChange={(e) => {
                            declareWallet.setValue(e.target.checked)
                            declareWallet.setError("");
                          }}
                          label={"I declare ownership of this wallet"}
                        />
                        {declareWallet.error && <span className="text-error-500 text-xs pt-0.5">{declareWallet.error}</span>}
                      </div>
                    )}

                    {walletType.value === "CUSTODIAL" && (
                      <CheckBox
                        id="not_in_the_list"
                        checked={VASPNotInList.value}
                        onChange={(e) => {
                          VASPNotInList.setValue(e.target.checked);
                          selectedVASP.setValue("");
                          beneficiaryVASPName.setValue("");
                        }}
                        label={"VASP not in the list"}
                      />
                    )}

                    <hr className="w-full mt-4 border-divider pt-10" />
                  </>
                )}

                <div className="grid grid-cols-1 sm:grid-cols-6 mt-3">
                  <ConfirmWithdrawCrypto
                    wallteAddress={walletAddress.value}
                    isModalOpen={confirmModal}
                    setIsModalOpen={(open) => {
                      if (validateWithdraw()) return;
                      setConfirmModal(open);
                    }}
                    loading={loadingNetworks}
                    handleWithDraw={handleWithdraw}
                  >
                    <PrimaryButton
                      text="Submit"
                      disabled={!isContinueEnabled}
                    />
                  </ConfirmWithdrawCrypto>
                </div>
              </>
            )}
          </div>
        </main>
      )}

      {isOTPModalOpen && (
        <TransactionOTPModal
          isLoading={isLoading}
          setisLoading={setIsLoading}
          TrnId={trn_id}
          setTrnId={setTrnId}
          isModalOpen={isOTPModalOpen}
          setIsModalOpen={setIsOTPModalOpen}
          handleTransaction={handleWithdraw}
          reduxaction={verifyTROTP}
          navigateUrl={"/crypto"}
          handleViewTransaction={handleViewTransaction}
        />
      )}
    </>
  );
};

export default Withdraw;
